export const EMP_ATTENDANCE = "emp_attendance";